// extracted by mini-css-extract-plugin
export var actionText = "_sh-4";
export var container = "_sh-0";
export var leftSection = "_sh-1";
export var rightSection = "_sh-2";
export var settingsButton = "_sh-6";
export var settingsIcon = "_sh-7";
export var shortcut = "_sh-5";
export var shortcutGroup = "_sh-3";